<div class="row">
  <div *ngIf="ContractsList?.length==0;then NoContracts else Contracts"></div>

  <ng-template #NoContracts>
    <div class="col-md-12">
      <p> {{ 'NoDataFound' | translate }}</p>
    </div>
  </ng-template>

  <ng-template #Contracts>
    <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let contract of ContractsList">
      <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
        <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
          <mat-card-title class="mat-mdc-card-title text-white">{{ contract.workShopName| subString:20
            }}</mat-card-title>
          <div class="d-flex divIcons">
            <i-tabler name="eye" class="icon-20 d-flex clickIcon" (click)="ViewContractDetails(contract.id)"></i-tabler>
          </div>
        </mat-card-header>
        <mat-card-content class="mat-mdc-card-content">
          <table class="table w-100">
            <tr>
              <td>
                <i-tabler name="Phone" class="icon-15 d-flex icon"></i-tabler>
              </td>
              <td><span class="span-title">{{ 'Phone' | translate }}</span></td>
              <td><span> {{ contract.workShopPhone }}</span></td>
            </tr>
            <tr>
              <td>
                <i-tabler name="map-pins" class="icon-15 d-flex icon"></i-tabler>
              </td>
              <td><span class="span-title">{{ 'Address' | translate }} </span></td>
              <td><span>{{ contract.workShopAddress | subString:15 }}</span></td>
            </tr>
            <tr>
              <td>
                <i-tabler name="discount" class="icon-15 d-flex icon"></i-tabler>
              </td>
              <td><span class="span-title">{{ 'contractValue' | translate }}</span></td>
              <td><span> {{ contract.totalContract }} {{ 'EGP' | translate }}</span></td>
            </tr>
            <tr>
              <td>
                <i-tabler name="calendar-due" class="icon-15 d-flex icon"></i-tabler>
              </td>
              <td><span class="span-title">{{ 'addedDate' | translate }}</span></td>
              <td><span> {{ contract.addedDate }}</span></td>
            </tr>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-template>
</div>